<div class="quill-view-container">
  <quill-view [content]="content" format="object" theme="snow"></quill-view>
</div>
